import defaultSettings from '@/settings'

const title = defaultSettings.title || 'Dating-ol'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
